import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import VxConsultLogo from './VxConsultLogo';

/**
 * Confirmação ao trocar motorista ou veículo de uma carga que já tem pesquisa VX concluída ou em andamento.
 */
const ProgramacaoHavanVxAlteracaoModal = ({ show, titulo, mensagem, detalhe, onCancel, onConfirm }) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <HeaderContent>
        <Modal.Title>{titulo}</Modal.Title>
        <VxConsultLogo size="sm" />
      </HeaderContent>
    </Modal.Header>
    <Modal.Body>
      <Mensagem>{mensagem}</Mensagem>
      {detalhe ? <Detalhe>{detalhe}</Detalhe> : null}
    </Modal.Body>
    <Modal.Footer>
      <ButtonWithLoading variant="outline-secondary" type="button" onClick={onCancel}>Não alterar</ButtonWithLoading>
      <ButtonWithLoading variant="warning" type="button" onClick={onConfirm}>Continuar e alterar</ButtonWithLoading>
    </Modal.Footer>
  </Modal>
);

ProgramacaoHavanVxAlteracaoModal.propTypes = {
  show: PropTypes.bool,
  titulo: PropTypes.string,
  mensagem: PropTypes.string,
  detalhe: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

ProgramacaoHavanVxAlteracaoModal.defaultProps = {
  show: false,
  titulo: 'Consulta VX em uso',
  mensagem: '',
  detalhe: ''
};

export default ProgramacaoHavanVxAlteracaoModal;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding-right: 16px;
`;

const Mensagem = styled.p`
  margin-bottom: 10px;
  color: #24344d;
  font-size: 15px;
  font-weight: 600;
`;

const Detalhe = styled.p`
  margin-bottom: 0;
  color: #6c757d;
  font-size: 13px;
`;
